// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"fde45130","220":"fbc891b0","250":"2be37c0e","371":"cb196b9b","396":"e599f232","467":"145b72dd","472":"048260e8","477":"bd90ae7c","667":"1837026d","676":"628b4242","722":"6f4033cd","770":"7c1670cd","791":"fec55d15","977":"316e12fa"}[chunkId] + ".chunk.js";
};